import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useHistory } from "react-router-dom";
const Profile = () =>{
    document.body.style.backgroundColor = "#F6F6F6"
    const history = useHistory()
    return (
        <div>
            <Header whihOne="profile"/>
            <section id="section_shop">
            <div className="row col-12">
                        <div className="col-sm-3" id="left_side_profile">
                        <div id="nav_profile">
                            <p id="nav_profile_title">Setting account</p>
                            <p id="nav_profile_details">
                            You can change or add more infomation
                            </p>
                            <hr  style={{color:"#CCCCCC"}}/>
                            <ul id="profile_nav_ul">
                                <li id="active">User Profile</li>
                                <li 
                                 onClick={(()=>{
                                    history.push({
                                        pathname:"/profile/change/password"
                                    })
                                 })}
                                >Change Password</li>
                            </ul>
                        </div>
                        </div>
                        <div className="col">
                            <div id="right_side_profile_div">
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Your Name</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="text" placeholder="First Name" id="profile_inputs" />
                                            </div>
                                            <div className="col ">
                                            <input type="text" placeholder="Last Name" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">User Name</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="text" placeholder="User Name" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Gender</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="radio" id="Gender" name="Gender" value="Female"></input>
                                            <label id="gender_lable_w">Female</label>
                                            <input type="radio" id="Gender" name="Gender" value="Male"></input>
                                            <label id="gender_lable_w">Male</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Email</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="email" placeholder="Email" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Phone Number</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="email" placeholder="Phone Number" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Where You Live </p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="email" placeholder="Where You Live " id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                <div className="col ">
                                <button id="button_save_profile">Save Change</button>
                                </div>
                                </div>
                            </div>
                        </div>
            </div>            
            </section>
            <Footer />
        </div>
    )
}
export default Profile;
